import * as RadixTabs from "@radix-ui/react-tabs";
import styled from "styled-components";
import { getThemeMedia, getThemeSpace } from "../helpers";
export const StyledTabs = styled(RadixTabs.Root) `

	width: 100%;

	overflow: hidden;
`;
export const StyledList = styled(RadixTabs.List) `
	display: flex;
	flex-shrink: 0;
	gap: 4px;
	padding: 0 16px;
`;
export const StyledTrigger = styled(RadixTabs.Trigger) `
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;

	width: 50%;
	height: 48px;

	border: 1px solid var(--text-disable);
	border-bottom: 0;
	border-radius: 8px 8px 0 0;
	background-color: var(--surface-white);

	cursor: pointer;

	h2 {
		font-weight: 500;
	}

	&[data-state='active'] {
		border-color: var(--surface-accent);
		border-width: 2px;

		&::after {
			content: '';
			position: absolute;
			width: 100%;
			height: 5px;
			background-color: var(--neutral-white);
			bottom: -2px;
			z-index: 10;
		}

		h2 {
			color: var(--text-link);
			text-decoration: underline;
		}
	}
`;
export const StyledContent = styled(RadixTabs.Content) `
	padding: ${getThemeSpace("48")} ${getThemeSpace("24")};

	background-color: var(--surface-white);
	border-radius: 8px;
	border: 2px solid var(--surface-accent);

	@media screen {
		@media (min-width: ${getThemeMedia("medium")}) {
			padding: ${getThemeSpace("48")} ${getThemeSpace("24")};
		}
	}
`;
//# sourceMappingURL=styles.js.map